import React from 'react'



export default function BuildLPG(props) {

    const formatRates = (rates) => {
        return parseFloat(rates).toFixed(3) + " ¢";
    };
    
    const formatDollarRates = (rates) => {
      if (props.noGst) {
        rates = rates * 1.15;
      }
      return "$" + parseFloat(rates).toFixed(2);
    };

    const formatKey = (key) => {
        let k = key.replace(/([A-Z])/g, " $1").trim();
        return k;
    };

    const LpgRates = () => {

        const LpgHtml = (
            <React.Fragment>
              <tr style={{ marginBottom: "10px", display: "block" }}>
                <td style={{ paddingLeft: "0" }}>
                  <b>Standard Rates</b>
                </td>
              </tr>
              {Object.entries(props.values.LPGDataFromDB[0]).map(
                ([key, value]) => (
                  <React.Fragment>
                    <tr key={key} className="tr-border-bottom">
                      <td align="left" style={{ paddingLeft: "0" }} className="lpg-left">
                        {formatKey(key)}
                      </td>
                      {/* <td align="right">{key==='Cylinder Rental' ? formatDollarRates(value-(props.values.allEnergyDiscount/100))+' /Day' : formatDollarRates(value)+' /Cylinder'}</td> */}
                      <td align="right" className="lpg-right">
                        {key === "CylinderRental"
                          ? formatDollarRates(value) + " /Day"
                          : formatDollarRates(value) + " /Cylinder"}
                      </td>
                    </tr>
                  </React.Fragment>
                )
              )}
              <tr id="allEnergyDiscount" className="tr-border-bottom">
                <td align="left" style={{ paddingLeft: "0" }} className="lpg-left">
                  All Energy Discount
                </td>
                <td align="right" className="lpg-right lpg-green">
                  -
                  {formatDollarRates(props.values.allEnergyDiscount / 100) +
                    " /Day"}
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "0", marginTop: "20px", marginBottom: "6px", display: "block" }}>
                  <b>Urgent Cylinder Delivery</b>
                </td>
              </tr>
              {Object.entries(props.values.LPGDataFromDB[1]).map(
                ([key, value]) => (
                  <React.Fragment>
                    <tr key={key} className="tr-border-bottom">
                      <td align="left" style={{ paddingLeft: "0" }} className="lpg-left">
                        {formatKey(key)}
                      </td>
                      <td align="right" className="lpg-right">
                        {value === 0
                          ? "N/A"
                          : key === "CylinderRental"
                          ? formatDollarRates(value) + "/Day"
                          : formatDollarRates(value)}
                      </td>
                    </tr>
                  </React.Fragment>
                )
              )}
            </React.Fragment>
          );
         
        return LpgHtml;
    
    }
    
    return (
        <React.Fragment>
            <div className="MuiPaper-root MuiTableContainer-root MuiPaper-elevation1 MuiPaper-rounded lpg-parent-wrapper">
                <table className="MuiTable-root jss58" aria-label="table" id="lgp-service-table">
                    <tbody className="MuiTableBody-root jss60" style={{ border: "none" }}>
                        {LpgRates()}
                    </tbody>
                </table>
                <table>
                  <tbody className="MuiTableBody-root jss60" style={{ border: "none" }}>
                    <tr className="tr-border-bottom">
                      <td align="left" className={`lpg-left ${props.noGst ? 'gst-green' : ''}`} style={{ paddingLeft: "0px" }}><strong>{props.noGst ? 'With GST' : 'With GST'}</strong></td>
                      <td align="right" className="lpg-right" style={{ textAlign: "right" }}>
                        <label className="service-checkbox">
                          <input
                              type="checkbox"
                              id="noGstCheckbox"
                              name="noGstCheckbox"
                              checked={props.noGst} // Use props.noGst
                              onChange={props.handleNoGstChange} // Use props.handleNoGstChange
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="lpgP" dangerouslySetInnerHTML={{__html: props.noGst ? props.values.LPGRatesGstTableFootNote : props.values.LPGRatesTableFootNote}}></div>
            </div>
        </React.Fragment>
      )
  }